import { Component, AfterViewInit, ElementRef, EventEmitter, forwardRef, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR, NgControl } from '@angular/forms';
import { Observable ,  Subscription  } from 'rxjs';

import { ApiError, BaseTypeahead, BaseTypeaheadService, MessageService } from '../../../core';
import { Cidade } from '../cidade';
import { CidadeTypeaheadHttpService } from './cidade-typeahead-http.service';

import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';
import { RegiaoLocalizacoesGatewayService } from '../../regiao/services';
@Component({
    selector: 'sgt-typeahead-cidade',
    templateUrl: './typeahead-cidade.component.html',
    styleUrls: ['./typeahead-cidade.component.less'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => TypeaheadCidadeComponent), multi: true },
    ]
})
export class TypeaheadCidadeComponent implements OnInit, AfterViewInit, BaseTypeahead<Cidade> {
    @Input() entity: Cidade;
    @Output() ngModelChange = new EventEmitter<Cidade>();

    @Input() required: any;
    @Input() disabled: any;
    @Input() readonly: any;
    @Input() ngControl: NgControl;
    @Input() autofocus = false;
    @Input() dropup = false;
    @Input() typeaheadOptionsInScrollableView = 5; // Quantidade de itens visíveis no no scroll do typeahead
    @Output() typeaheadChange = new EventEmitter<Cidade>();
    @Output() entitySelected = new EventEmitter<Cidade>(); // Emite evento quando a entidade foi selecionada no typeahead
    @Output() clearEntity = new EventEmitter<any>(); // Emite evento quando remover a entity

    /** Se deve considerar as cidades das localizações das regiões do usuário */
    @Input() useLocalizacoes = false;
    /** Estado para filter as cidades */
    @Input() idEstadoFilter: number = null;
    /** ID da região geográfica intermediária para filtrar as cidades */
    @Input() idRegiaoGeograficaIntermediariaFilter: number = null;
    /** ID da região geográfica imediata para filtrar as cidades */
    @Input() idRegiaoGeograficaImediataFilter: number = null;

    @ViewChild('inputTypeahead', {static: true}) inputTypeahead: ElementRef;
    typeaheadOptionsLimit = 1000; // Quantidade máxima de registros exibidos no typeahead
    typeaheadSelected: string;
    typeaheadToken: string;
    typeaheadDataSource: Observable<Cidade[]>;
    typeaheadNoResults: boolean;

    currentRequest: Subscription;
    isLoading: boolean;

    propagateChange: any = () => {};

    constructor(private baseTypeaheadService: BaseTypeaheadService,
                private messageService: MessageService,
                private cidadeTypeaheadHttpService: CidadeTypeaheadHttpService,
                private regiaoLocalizacoesGatewayService: RegiaoLocalizacoesGatewayService) { }

    ngOnInit() {
        this.createDataSource();
    }

    ngAfterViewInit() {
        if (this.autofocus) {
            jQuery(this.inputTypeahead.nativeElement).focus();
        }
    }

    /** Cria o data source do typeahead */
    createDataSource() {
        this.typeaheadDataSource = new Observable((observer: any) => {
            if (this.currentRequest) {
                this.currentRequest.unsubscribe();
            }

            // Obtem as cidades através das localizações das regiões do usuário
            if (this.useLocalizacoes) {
                this.regiaoLocalizacoesGatewayService.getLocalizacoes(null)
                    .then(localizacoes => {
                        observer.next(localizacoes?.getCidades(this.idEstadoFilter, this.idRegiaoGeograficaIntermediariaFilter, this.idRegiaoGeograficaImediataFilter, this.typeaheadToken) ?? [])
                    });
            } else { // Pesquisa no typeahead
                this.currentRequest = this.cidadeTypeaheadHttpService.search(this.typeaheadToken, this.idEstadoFilter, this.idRegiaoGeograficaIntermediariaFilter, this.idRegiaoGeograficaImediataFilter, this.typeaheadOptionsLimit)
                                            .subscribe(
                                                (entities: Cidade[]) => observer.next(entities),
                                                (error: ApiError) => {
                                                    this.messageService.error(error.message, 'Ocorreu um erro ao pesquisar as cidades. Tente novamente', error);
                                                    observer.next([]);
                                                }
                                            );
            }

        });
    }


    /** Ao digitar no input do typeahead */
    onKeyup(e: KeyboardEvent) {
        this.baseTypeaheadService.onKeyup(this, e);
    }

    /** Ao sair do input do typeahead */
    onBlur() {
        this.baseTypeaheadService.onBlur(this);
        if (!this.entity) {
            this.clearEntity.emit();
        }
    }


    /** Verifica se o typeahead possui resultados */
    onChangeTypeaheadNoResults(noResults: boolean) {
        this.typeaheadNoResults = noResults;
    }

    /** Ao selecionar a cidade no typeahead */
    onSelectEntity(tm: TypeaheadMatch) {
        this.baseTypeaheadService.onSelectEntity(this, tm);
        this.entitySelected.emit(this.entity);
    }

    /** Limpa o typeahead e o model */
    clear() {
        this.baseTypeaheadService.clear(this);
        this.clearEntity.emit();
    }

    /** Seta o foco no input */
    setFocus() {
        jQuery(this.inputTypeahead.nativeElement).focus();
    }

   /** Quando recebe um objeto Cidade de "fora" do component */
    writeValue(value: Cidade) {
        if (value) {
            this.baseTypeaheadService.writeValue(this, value, value.nome);
        } else {
            this.baseTypeaheadService.writeValue(this, null);
        }
    }

    /** Propaga as alterações */
    registerOnChange(fn) {
        this.propagateChange = fn;
    }

    registerOnTouched() {}
}
